module.exports = __webpack_public_path__ + "img/documents_active.ea018857.svg";